import React from 'react'
import HeroSection from '../../Components/HeroSection/HeroSection'

const Home = () => {
  return (
    <HeroSection/>
  )
}

export default Home